import axios, { AxiosResponse, AxiosError } from "axios";

// export const BASE_URL = "http://localhost:8000";
export const BASE_URL = "https://surface-interval-server-931350853391.us-central1.run.app";

class APIService {
    private axiosInstance;

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: BASE_URL,
            timeout: 10000,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${localStorage.getItem("si_token")}`,
            },
        });

        this.axiosInstance.interceptors.request.use((config) => {
            const token = localStorage.getItem("si_token");
            if (token) {
                config.headers.Authorization = `Token ${token}`;
            }
            return config;
        });
    }

    // GET request
    public async fetchData<T>(endpoint: string): Promise<T> {
        try {
            const response: AxiosResponse<T> = await this.axiosInstance.get(endpoint);
            return response.data;
        } catch (error: unknown) {
            this.handleError(error as AxiosError);
            throw error;
        }
    }

    // POST request
    public async sendData<T>(endpoint: string, data: object): Promise<T> {
        try {
            const response: AxiosResponse<T> = await this.axiosInstance.post(endpoint, data);
            return response.data;
        } catch (error: unknown) {
            this.handleError(error as AxiosError);
            throw error;
        }
    }

    // Handle errors
    private handleError(error: AxiosError) {
        if (error.response) {
            // The request was made, but the server responded with a status code that falls out of the range of 2xx
            console.error("Response Error:", error.response.data);
        } else if (error.request) {
            // The request was made but no response was received
            console.error("Request Error:", error.request);
        } else {
            // Something happened in setting up the request that triggered an error
            console.error("Error:", error.message);
        }
    }

    // DELETE request
    public async deleteData<T>(endpoint: string): Promise<T> {
        try {
            const response: AxiosResponse<T> = await this.axiosInstance.delete(endpoint);
            return response.data;
        } catch (error: unknown) {
            this.handleError(error as AxiosError);
            throw error;
        }
    }

    // PUT request
    public async updateData<T>(endpoint: string, data: object): Promise<T> {
        try {
            const response: AxiosResponse<T> = await this.axiosInstance.put(endpoint, data);
            return response.data;
        } catch (error: unknown) {
            this.handleError(error as AxiosError);
            throw error;
        }
    }
}

export default new APIService();
